<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            <q-icon
              name="attach_file"
            ></q-icon>
            Asociar acción
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <HeaderPopUp/>
          <slot name="body">
            <!--tabla de acciones-->
            <q-table
              title="Resumen de acciones"
              :data="rows"
              :columns="columns"
              row-key="name"
              selection="multiple"
              :selected.sync="selected"
            >
              <template v-slot:header="props">
                <q-tr :props="props">
                  <q-th auto-width> </q-th>
                  <q-th
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                  >
                    {{ col.label }}
                  </q-th>
                </q-tr>
              </template>

              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td auto-width>
                    <q-checkbox
                      color="primary"
                      v-model="props.selected"
                      @input="props.expand = !props.expand"
                    ><span v-if="props.selected && props.row.arrayLineasActuacionAdded.length > 0">Asociada</span></q-checkbox>
                  </q-td>
                  <q-td
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                  >
                    <div v-if="col.name === 'objetivosRelacionados'">
                      <q-img
                        v-for="obj in props.row.objetivosRelacionados"
                        v-bind:key="obj.file.url"
                        :src="getImgObjetivo(obj.file)"
                        :alt="getImgObjetivo(obj.file).url"
                      >
                        <q-tooltip anchor="bottom middle" :offset="[0, 10]">
                          <strong>{{obj.name}}</strong>
                        </q-tooltip>
                      </q-img>
                    </div>
                    <div v-if="col.name === 'fase'">
                      <QChipFases :value="col.value"/>
                    </div>
                    <div v-if="col.name !== 'objetivosRelacionados' && col.name !== 'fase'">
                      {{ col.value }}
                    </div>
                  </q-td>
                </q-tr>
                <q-tr v-show="props.expand" :props="props" :id="props.row.id">
                  <q-td colspan="100%">
                    <div class="text-left">
                      <!--Linea de actuación-->
                      <div class="row">
                        <q-select
                          label="Linea de actuación"
                          class="input col-12 required"
                          outlined
                          :options="optionsLineasActuacion ? optionsLineasActuacion : 'No hay datos'"
                          option-value="id"
                          option-label="name"
                          v-model="optionLineaActuacionSelected"
                          @input="addLinea(props.row.arrayLineasActuacionAdded)"

                        >
                          <template v-slot:error>
                            <span>Dato obligatorio.</span>
                          </template>
                        </q-select>
                      </div>
                      <div class="row">
                        <div class="divChip" v-for="(linea, index) in props.row.arrayLineasActuacionAdded" :key="index">
                          <div class="divTextChip">{{linea.name}} </div>
                          <div><q-icon class="iconCancel cursor-pointer" size="sm" name="cancel" @click="removeLinea(index, props.row.id)"></q-icon></div>
                        </div>
                      </div>
                    </div>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </slot>
        </q-card-section>

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cancelar"
            @click="cancel()"
          />
          <q-btn
            label="GUARDAR"
            class="bPrincipal"
            padding="xs lg"
            @click="save()"
            :disabled="btnDisabled"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <DialogDelete
      v-model="showDialogCancelAsociaciones"
      :showIcon="false"
      :txtContainer="
        `Si cancela se perderán los cambios no guardados ¿Desea continuar?`
      "
      labelDelete="SÍ, CONTINUAR"
      @save="cancelEdit()"
    />
  </div>
</template>

<script>
import { QTable, QTh, QTr, QTd, QCheckbox, QDialog, QImg } from 'quasar';
import * as types from '@/storeModules/NGUD/types';
import { required } from 'vuelidate/lib/validators';
import Resources from '@/components/shared/mixins/Resources.js';
import QChipFases from '@/components/PlanAccion/components/QChipFases.vue';
import HeaderPopUp from '@/components/PlanAccion/components/HeaderPopUp.vue';
import { mapGetters } from 'vuex';
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';

export default {
  components: {
    QTable,
    QTh,
    QTr,
    QTd,
    QCheckbox,
    QDialog,
    QImg,
    QChipFases,
    HeaderPopUp,
    DialogDelete
  },
  mixins: [Resources, Message, Validation],
  props: {
    value: {
      required: true
    },
    listadoAccionesParaAsociar: Array,
    listadoAcciones: Array
  },
  validations: {
    nombre: { required },
    periodoVigencia: { required },
    optionSelected: { required }
  },
  computed: {
    ...mapGetters({
      objetivoEspecifico: 'NGUD/objetivoEspecifico'
    })
  },
  data () {
    return {
      valueLocal: this.value,
      selected: [],
      optionLineaActuacionSelected: null,
      optionsLineasActuacion: [],
      btnDisabled: false,
      showDialogCancelAsociaciones: false,
      columns: [
        {
          name: 'name',
          label: 'Nombre de la acción',
          align: 'left',
          field: 'name',
          sortable: true,
          style: 'max-width: 300px'
        },
        {
          name: 'fase',
          label: 'Fase',
          align: 'left',
          field: 'fase',
          sortable: true
        },
        {
          name: 'plazo',
          label: 'Plazo',
          align: 'left',
          field: 'plazo',
          sortable: true
        },
        {
          name: 'objetivosRelacionados',
          label: 'Otros objetivos relacionados',
          align: 'left',
          field: 'objetivosRelacionados',
          sortable: true
        },
        {
          name: 'agenteResponsable',
          label: 'Agente responsable',
          align: 'left',
          field: 'agenteResponsable',
          sortable: true
        }
      ],
      rows: []
    };
  },
  created () {
    this.rows = this.listadoAcciones;
    this.clean();
    // lineas de actuación
    this.$store
      .dispatch(types.ACTION_GET_OBJETIVOS_ESPECIFICOS_LINEAS_ACTUACION, { idObjetivo: this.objetivoEspecifico.id })
      .then(response => {
        this.optionsLineasActuacion = response.data;
      });
    this.loadSelected();

    // creo mi array de acciones con lineas de actuación
    this.rows.forEach(accion => {
      accion['arrayLineasActuacionAdded'] = [];
    });
  },
  watch: {
    value: {
      handler: function () {
        this.clean();
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    },
    listadoAccionesParaAsociar () {
      if (this.listadoAccionesParaAsociar.length > 0) {
        this.rows.push(this.listadoAccionesParaAsociar[0]);
      }
    },
    listadoAcciones () {
      this.rows = this.listadoAcciones;
      this.rows.forEach(accion => {
        accion['arrayLineasActuacionAdded'] = [];
      });
    },
    selected () {
      this.checkDisabled();
    }
  },
  methods: {
    loadSelected () {
      this.selected = this.rows
        .filter(n => n.estado === true)
        .map(n => {
          if (n.estado === true) {
            return { id: n.id };
          }
        });
    },

    cancel () {
      this.showDialogCancelAsociaciones = true;
    },
    cancelEdit () {
      this.showDialogCancelAsociaciones = false;
      this.clean();
      this.$emit('input', false);
      this.$v.$reset();
    },
    clean () {
      this.selected = [];
      this.rows.forEach(accion => {
        accion['arrayLineasActuacionAdded'] = [];
      });
      this.optionLineaActuacionSelected = null;
    },
    addLinea (arrayLineas) {
      let newName = this.optionLineaActuacionSelected.name;
      let repeated = false;
      arrayLineas.forEach(linea => {
        if (linea.name === newName) {
          this.showError('La linea de actuación ya está añadida, no se puede volver a añadir.');
          repeated = true;
        }
      });

      if (repeated === false) {
        arrayLineas.push(this.optionLineaActuacionSelected);
      }
      this.optionLineaActuacionSelected = null;
      this.checkDisabled();
    },
    removeLinea (index, idRow) {
      let arrayCopy = [];
      arrayCopy = [...this.rows];
      arrayCopy.forEach(accion => {
        if (accion.id === idRow) {
          accion.arrayLineasActuacionAdded.splice(index, 1);
        }
      });
      this.rows = [...arrayCopy];

      this.optionLineaActuacionSelected = null;
      this.checkDisabled();
    },
    save () {
      this.$v.$touch();
      if (!this.checkForm()) {
        this.selected.forEach(accion => {
          let index = this.rows.indexOf(accion);
          this.rows.splice(index, 1);
        });

        this.$emit('input', false);
        this.$eventHub.$emit('saveAccionesAsociadas', this.selected);
      }
    },
    getImgObjetivo (file) {
      let res = this.searchResource(file, 'imagen');
      return res ? res.url : this.getDefaultResource('imagen');
    },
    checkDisabled () {
      this.btnDisabled = false;
      if (this.selected.length > 0) {
        this.selected.forEach(accion => {
          if (accion.arrayLineasActuacionAdded.length === 0) {
            this.btnDisabled = true;
          }
        });
      }
      return this.btnDisabled;
    },
    checkForm () {
      let valid = false;
      if (this.selected.length > 0) {
        this.selected.forEach(accion => {
          if (accion.arrayLineasActuacionAdded.length === 0) {
            valid = true;
          } else {
            valid = false;
          }
        });
      }
      return valid;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .q-table__card {
    box-shadow: none;
    padding: 0 !important;
    border: solid 3px #e9f4f6;
    border-radius: 12px;
  }
  .q-table--no-wrap td {
    white-space: normal;
  }
}
.card-authorization {
  min-width: 90%;
  border-radius: 12px;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  .container-auth {
    padding-top: 20px;
    padding-bottom: 25px;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}

.q-img {
  margin-right: 5px;
  height: 40px;
  width: 40px;
}
.divChip{
    color: #042857 !important;
    font-family: DINPro;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.56px;
    border: solid 1px #979797;
    border-radius: 30px !important;
    padding: 10px;
    margin-bottom: 5px;
    align-items: center;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .iconCancel{
      color: grey;
      padding: 5px;
      margin: 0px;
    }
    .divTextChip{
      padding-left: 5px;
    }
  }
  .q-select{
    padding-bottom: 15px;
  }
  .text-left{
    max-width: 1500px;
  }
</style>
